"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.monitorPageScroll = exports.nextPageResize = exports.resetTextSize = exports.decreaseTextSize = void 0;
const effects_1 = require("redux-saga/effects");
const redux_saga_1 = require("redux-saga");
const root_1 = require("src/utils/root");
const actions_1 = require("../actions");
const scroll_detector_1 = require("./scroll-detector");
const consts_1 = require("./consts");
// высота экрана в которую еще получается вписать содержимое опроса
// const MIN_WINDOW_HEIGHT = 285;
const MIN_FONT_SIZE = 25;
const FONT_SIZE_STEP = 1.25;
const RESIZE_DELAY = 1;
let isTextResizedToMin = false;
// eslint-disable-next-line max-statements
function* decreaseTextSize() {
    const container = yield (0, effects_1.call)(root_1.getRoot);
    const containerFontSize = parseFloat(container.style.getPropertyValue('font-size'));
    if (containerFontSize <= MIN_FONT_SIZE) {
        if (!isTextResizedToMin) {
            isTextResizedToMin = true;
            yield (0, effects_1.put)((0, actions_1.testResizedToMin)());
        }
        return;
    }
    const newSize = containerFontSize - FONT_SIZE_STEP;
    container.style.fontSize = `${newSize}px`;
    container.style.setProperty('--rem', `${newSize}px`);
    yield (0, redux_saga_1.delay)(RESIZE_DELAY);
    const surveyHasScroll = yield (0, effects_1.call)(scroll_detector_1.checkSurveyHasScroll);
    if (surveyHasScroll) {
        yield (0, effects_1.call)(decreaseTextSize);
    }
}
exports.decreaseTextSize = decreaseTextSize;
function* resetTextSize() {
    const container = yield (0, effects_1.call)(root_1.getRoot);
    container.style.fontSize = '100px';
    container.style.setProperty('--rem', '100px');
}
exports.resetTextSize = resetTextSize;
function* nextPageResize() {
    yield (0, effects_1.call)(resetTextSize);
    const hasScroll = yield (0, effects_1.call)(scroll_detector_1.isVideoModeWithScroll);
    if (hasScroll) {
        yield (0, effects_1.call)(decreaseTextSize);
    }
}
exports.nextPageResize = nextPageResize;
// export function* checkWindowHeight() {
//     if (window.innerHeight < MIN_WINDOW_HEIGHT) {
//         yield put(surveySkip());
//     }
// }
function* monitorPageScroll() {
    const hasScroll = yield (0, effects_1.call)(scroll_detector_1.isVideoModeWithScroll);
    if (hasScroll) {
        yield (0, effects_1.call)(decreaseTextSize);
    }
    yield (0, redux_saga_1.delay)(1000);
    yield (0, effects_1.call)(monitorPageScroll);
}
exports.monitorPageScroll = monitorPageScroll;
function* router() {
    // yield takeLatest('LANG_SET', checkWindowHeight);
    yield (0, effects_1.takeLatest)(consts_1.SCROLL_CHECK_ACTIONS, monitorPageScroll);
    yield (0, effects_1.takeLatest)('PAGE_SWITCHED', nextPageResize);
    yield (0, effects_1.takeLatest)('LEFT_LAST_PAGE', resetTextSize);
}
exports.router = router;
